import { clamp } from '~/lib/number-formats';
import { type Instrument, InstrumentState } from '~/models/instruments';

const computeProgress = (instrument: Instrument | undefined) => {
  if (
    !instrument ||
    instrument.State === InstrumentState.InPreparation ||
    !instrument.FECurrentAmount ||
    !instrument.Amount ||
    instrument.HideResults
  ) {
    return 0;
  }

  return clamp(Math.floor((instrument.FECurrentAmount / instrument.Amount) * 100), 0, 100);
};

export function useInstrumentsProgress(instrument: Readonly<Ref<Instrument | undefined>>) {
  const progress = ref(computeProgress(instrument.value));

  watch(instrument, () => {
    progress.value = computeProgress(instrument.value);
  });

  return progress;
}
